<span>
    <img *ngIf="icon" src="{{ partner?.iconPath }}" alt="{{ partner?.name }}" height="{{ partner?.size || size }}" />
    <img *ngIf="logo" src="{{ partner?.logoPath }}" alt="{{ partner?.name }}" height="{{ partner?.size || size }}" />
    <span class="pl-1" *ngIf="!onlyIcon && !logo">{{ partner?.name }}</span>
</span>
